import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const FamiliplusSubBase = (): JSX.Element => {
  const { t, i18n } = useTranslation('component');
  return (
    <>
      <Box sx={{ mb: '32px' }}>
        <Link
          component={RouterLink}
          to={`/${i18n.resolvedLanguage}/${i18n.resolvedLanguage == 'fr' ? 'Compte' : 'Account'}/Familiplus`}
          className="iconTextLink"
          id="returnFamiliplusLink">
          <ArrowBack sx={{ mr: '6px' }} fontSize="small" />
          {t('Buttons.Return')}
        </Link>
      </Box>
      <Outlet />
    </>
  );
};

export default FamiliplusSubBase;
